/**
 * hasEnoughTags.js
 *
 * @description A file that controls highlighting Faces that aren't properly trained on.
 */

export const threshold = 20
export const f1Threshold = 0.8
/**
 * Determines if a face has enough data to be considered properly trained.
 *
 * This is based on if the faces has an f1 score higher than the threshold.
 * If no score is designated, use the tag count instead.
 *
 * @export
 * @returns `true` if the Face has enough tags, else `false`.
 */
export function hasEnoughTags (face) {
  if (!face) {
    return false
  }

  if (face.f1_score) {
    const highEnoughF1Score = face.f1_score >= f1Threshold
    return highEnoughF1Score
  }

  const tagCount = face.images_tagged
  const hasEnough = tagCount >= threshold
  // if (!hasEnough) {
  // console.debug(`${face.person_name} has ${tagCount} tags. That is ${hasEnough ? '' : 'not '}enough tags.`)
  // }
  return hasEnough
}
